import React, { useEffect } from "react";
import AOS from "aos";
import page_json from "./config/config.json";
import { Helmet } from "react-helmet";
import ContactUsButton from "./ContactUsButton";
import HeroComponent from "./HeroComponent";
import config from "../config";

const textDataUrl = `${page_json.page_jsons.Salesforce}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function Salesforce() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <div data-aos="fade-up" className="salesforce">
      <Helmet>
        <meta
          name="description"
          content="Discover the power of strategic collaboration EM leads the way with Salesforce"
        />
        <title>Salesforce | Technologies | Engineersmind</title>
      </Helmet>

      <HeroComponent
        bgImageMobile={textData.layer1.mobilebannerimg}
        bgImage={textData.layer1.img}
        textContent={
          <>
            <h1>
              {textData.layer1.heading.text1}
              <span>{textData.layer1.heading.text2}</span>
              {textData.layer1.heading.text3}
              <span>{textData.layer1.heading.text4}</span>
              {textData.layer1.heading.text5}
            </h1>
            <p className="mb-4">{textData.layer1.body}</p>
          </>
        }
        breadcrumbs={
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home </a>
            </li>
            <li className="breadcrumb-item">
              <a href="/Technologies/Salesforce">Technologies </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Salesforce
            </li>
          </ol>
        }
      />
      <div className="container-fluid m-0 caseStudyContent">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h1>{textData.salesforceImplementationServices.title}</h1>
              <div className="row introductionsection digitalPortals-left-img-row">
                <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
                  <img
                    className="AIChatbot-introduction-img"
                    src={textData.salesforceImplementationServices.img}
                    alt="overview-img"
                  />
                </div>
                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
                  <div className="p-0">
                    <p className="text-20">
                      {textData.salesforceImplementationServices.description1}
                    </p>
                    <p className="text-20 mt-3">
                      {textData.salesforceImplementationServices.description2}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*<div className="alliances d-flex flex-column justify-content-center align-items-center ">
        <h1 className="text-white text-center">
          {textData.layer5.heading.text1}
          <span>{textData.layer5.heading.text2}</span>
          {textData.layer5.heading.text3}
        </h1>
        <ContactUsButton
          text={textData.layer5.button.text}
          link="#ContactForm"
          className="light"
        />
      </div> 
      */}

      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.salesforcePlatformSetup.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.salesforcePlatformSetup.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.salesforcePlatformSetup.description1}</p>
                <p className="mt-2">
                  {textData.salesforcePlatformSetup.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.salesforcePlatformSetup.keyFeatures.map(
                    (point, index) => {
                      return (
                        <li className="digitalPortals-list-point" key={index}>
                          <strong
                            dangerouslySetInnerHTML={{ __html: point.title }}
                          />
                          {" - "}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: point.description,
                            }}
                          />
                        </li>
                      );
                    }
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.customizationAndConfiguration.title}</span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.customizationAndConfiguration.description1}</p>
                <p className="mt-2">
                  {textData.customizationAndConfiguration.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.customizationAndConfiguration.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.customizationAndConfiguration.description3}</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.customizationAndConfiguration.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.systemIntegration.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.systemIntegration.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.systemIntegration.description1}</p>
                <p className="mt-2">
                  {textData.systemIntegration.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                {textData.systemIntegration.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.systemIntegration.description3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.dataServices.title}</span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.dataServices.description1}</p>
                <p className="mt-2">
                  {textData.dataServices.description2}
                </p>
                <p className="mt-2">{textData.dataServices.description3}</p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.dataServices.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.dataServices.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.analyticsAndDashboards.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.analyticsAndDashboards.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.analyticsAndDashboards.description1}</p>
                <p className="mt-2">
                  {textData.analyticsAndDashboards.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                {textData.analyticsAndDashboards.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.analyticsAndDashboards.description3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.userExperienceAndDesign.title}</span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.userExperienceAndDesign.description1}</p>
                <p className="mt-2">
                  {textData.userExperienceAndDesign.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.userExperienceAndDesign.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.userExperienceAndDesign.description3}</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.userExperienceAndDesign.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.agileDeliveryAndDevOps.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.agileDeliveryAndDevOps.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.agileDeliveryAndDevOps.description1}</p>
                <p className="mt-2">
                  {textData.agileDeliveryAndDevOps.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                {textData.agileDeliveryAndDevOps.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.agileDeliveryAndDevOps.description3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.testingAndQualityAssurance.title}</span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.testingAndQualityAssurance.description1}</p>
                <p className="mt-2">
                  {textData.testingAndQualityAssurance.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.testingAndQualityAssurance.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.testingAndQualityAssurance.description3}</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.testingAndQualityAssurance.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>


      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.postImplementationSupport.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.postImplementationSupport.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.postImplementationSupport.description1}</p>
                <p className="mt-2">
                  {textData.postImplementationSupport.description2}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                {textData.postImplementationSupport.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.postImplementationSupport.description3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid whyChoose ModernPortals">
        <div className="container">
          <h1>
            <span>{textData.whyChooseEngineersmind.title}</span>
          </h1>
          <p className="text-20 mb-4">
            {textData.whyChooseEngineersmind.description}
          </p>
        </div>
      </div>
    </div>
  );
}
export default Salesforce;
